import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-platform-drawer',
  templateUrl: './platform-drawer.component.html',
  styleUrl: './platform-drawer.component.scss',
  standalone: false
})
export class PlatformDrawerComponent implements OnInit {
  usage = `
      <ui-platform-drawer
        [visible]="visible"
        [inProgress]="inProgress"
        [confirmLabel]="'Confirm'"
        [cancelLabel]="'Cancel'"
        (closeDrawer)="closeDrawer()"
        (confirmDrawer)="confirmDrawer()"
      >
          <p>
              Content
          </p>
      </ui-platform-drawer>
    `;

  import = `
    import {UiPlatformDrawer} from 'ui-platform';
  `;

  visible = true;
  inProgress = false;

  constructor() {}

  ngOnInit(): void {}

  makeVisible(): void {
    this.visible = true;
  }

  closeDrawer(): void {
    this.visible = false;
  }

  toggleInProgress(): void {
    this.inProgress = !this.inProgress;
  }
}
